import { render } from "./Therapy.vue?vue&type=template&id=6089efdc&scoped=true"
import script from "./Therapy.vue?vue&type=script&lang=js"
export * from "./Therapy.vue?vue&type=script&lang=js"

import "./Therapy.vue?vue&type=style&index=0&id=6089efdc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6089efdc"]])

export default __exports__